core.directive('regonValidator', [
        function() {
            var definition = {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    ctrl.$validators.regonValidator = function(modelValue, viewValue) {
                        if (_.isEmpty(modelValue)) {
                            return true;
                        }

                        var regonRegex = /^\d{9}(\d{5})?$/;

                        if (regonRegex.test(modelValue) === false) {
                            return false;
                        }

                        var basicRegonLength = 9;
                        var basicRegonWeights = [8, 9, 2, 3, 4, 5, 6, 7];
                        var valid = isCorrect(modelValue, basicRegonWeights);

                        if (modelValue.length === basicRegonLength) {
                            return valid;
                        }

                        var extendedRegonWeights = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];

                        return valid && isCorrect(modelValue, extendedRegonWeights);

                        function isCorrect(regon, weights) {
                            var digitsToCheck = weights.length;
                            var checkDigit = parseInt(regon[digitsToCheck]);
                            var checksum = 0;

                            for (var i = 0; i < digitsToCheck; i++) {
                                checksum += regon[i] * weights[i];
                            }

                            checksum %= 11;
                            checksum %= 10;//checksum = checksum === 10 ? 0 : checksum;

                            return checksum === checkDigit;
                        }
                    }
                }
            };

            return definition;
        }]
);